import { Routes } from '@angular/router';
import { RoleGuard } from '../../core/guard/role.guard';
import { SingleDepartmentService } from '../../shared/services/single-department.service';
import { RouterOptionTab } from '../../shared/types/router-option-tab';
import { PACKING_BOX_SPECIFY_STATION } from '../../views/packing-box/tokens/printer-station';
import { PackingBoxViewAuthService } from '../../views/packing-box/services/auth.service';
import { TableService } from '../../core/components/table/table.service';
import { PackingBoxZebraTableService } from '../../views/packing-box/components/table/table-zebra.service';
import { WebSocketApiLabelService } from '../../api/elite/websockets/label.service';
import { PackingBoxViewService } from '../../views/packing-box/services/view.service';
import { PackingBoxViewApiService } from '../../views/packing-box/api/view.service';
import { PackingBoxViewZebraApiService } from '../../views/packing-box/api/view-zebra.service';
import {
  LidDepartmentService,
  LidPackingBoxAuthService,
} from '@dep-lids/services';
import { LIDS_ROLES_VIEWS_PERMISSIONS } from '@dep-lids/utils/roles-actions';

const schedulerOptionsTab: RouterOptionTab[] = [
  {
    name: 'Router',
    route: './',
    pathDestination: 'scheduler',
  },
  {
    name: 'Laser',
    route: './laser',
    pathDestination: 'laser',
  },
  {
    name: 'Sandblaster',
    route: './sandblaster',
    pathDestination: 'sandblaster',
  },
  {
    name: 'Moldeado',
    route: './molded',
    pathDestination: 'molded',
  },
];

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'scheduler' },
  {
    path: 'add-work-order',
    loadComponent: () =>
      import('./view-add-work-order/view-add-work-order.component').then(
        (m) => m.LidAddWorkOrderComponent
      ),
    canActivate: [RoleGuard],
    data: {
      breadcrumb: 'Form',
      expectedRole: LIDS_ROLES_VIEWS_PERMISSIONS.sharedActions.addWorkOrder,
    },
  },
  {
    path: 'scheduler',
    loadComponent: () =>
      import(
        '../../shared/components/routing-tabs/routing-tabs.component'
      ).then((m) => m.RoutingTabsComponent),
    canActivate: [RoleGuard],
    data: {
      breadcrumb: 'Scheduler',
      expectedRole: LIDS_ROLES_VIEWS_PERMISSIONS.sharedActions.scheduler,
      optionsTab: schedulerOptionsTab,
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./view-scheduler/scheduler.component').then(
            (m) => m.LidSchedulerComponent
          ),
        data: {
          optionsTab: schedulerOptionsTab,
          stage: 'Router',
          machine: 'Router',
        },
      },
      {
        path: 'laser',
        loadComponent: () =>
          import('./view-scheduler/scheduler.component').then(
            (m) => m.LidSchedulerComponent
          ),
        data: {
          optionsTab: schedulerOptionsTab,
          stage: 'Laser',
          machine: 'Laser',
        },
      },
      {
        path: 'sandblaster',
        loadComponent: () =>
          import('./view-scheduler/scheduler.component').then(
            (m) => m.LidSchedulerComponent
          ),
        data: {
          optionsTab: schedulerOptionsTab,
          stage: 'Sandblaster',
          machine: 'Sandblaster',
        },
      },
      {
        path: 'molded',
        loadComponent: () =>
          import('./view-scheduler/scheduler.component').then(
            (m) => m.LidSchedulerComponent
          ),
        data: {
          optionsTab: schedulerOptionsTab,
          stage: 'Molded',
          machine: 'Moldeo',
        },
      },
    ],
  },
  {
    path: 'validation',
    loadComponent: () =>
      import('./view-validation/view-validation.component').then(
        (m) => m.LidValidationComponent
      ),
    canActivate: [RoleGuard],
    data: {
      breadcrumb: 'Validation',
      expectedRole: LIDS_ROLES_VIEWS_PERMISSIONS.sharedActions.validation,
    },
  },
  {
    path: 'packing-box',
    loadComponent: () =>
      import('../../views/packing-box/packing-box.component').then(
        (m) => m.PackingBoxComponent
      ),
    canActivate: [RoleGuard],
    providers: [
      {
        provide: PackingBoxViewAuthService,
        useClass: LidPackingBoxAuthService,
      },
      { provide: TableService, useClass: PackingBoxZebraTableService },
      WebSocketApiLabelService,
      PackingBoxViewService,
      {
        provide: PackingBoxViewApiService,
        useClass: PackingBoxViewZebraApiService,
      },
    ],
    data: {
      breadcrumb: 'Lid',
      department: 'Lids',
      pageTitle: 'Crear etiquetas',
      companyType: 'sb',
      expectedRole: LIDS_ROLES_VIEWS_PERMISSIONS.sharedActions.packingBox,
    },
  },
  { path: '**', redirectTo: 'scheduler', pathMatch: 'full' },
];

export const LidsDepartmentRoutes = {
  path: 'lids',
  children: routes,
  providers: [
    { provide: SingleDepartmentService, useClass: LidDepartmentService },
    { provide: PACKING_BOX_SPECIFY_STATION, useValue: true },
  ],
};
